import { Objects, UIImages } from '../utils/Consts';
import BaseOverlay from './BaseOverlay';
import Utils from '../utils/Utils';

class ReplyOverlay extends BaseOverlay {
	constructor(scene, uiHandler, audioManager) {
		super(scene, uiHandler, audioManager);
		this.reply = this.uiHandler.createImage(Utils.centerX(), Utils.centerY(), UIImages.replyBasic)
			.setScale(0.3);
		this.assetContainer.add(this.reply);
		this.hide(false);
	}

	hide(hiddenByPlayer = true) {
		super.hide(hiddenByPlayer);
		this.reply.setVisible(this.visible);
		this.reply.disableInteractive();

		if (hiddenByPlayer && this.scene.gameState.replyFound === false) {
			this.scene.gameState.replyFound = true;
			this.scene.objectsManager.appearAnimation(Objects.replyLocated);
		}
	}

	show() {
		super.show();
		this.reply.setVisible(this.visible);
		this.reply.setInteractive();
	}
}

export default ReplyOverlay;
